import Vue from 'vue';

const SET_BANNERS = 'SET_BANNERS';
const SET_BANNER = 'SET_BANNER';
const UNSET_BANNER = 'UNSET_BANNER';

export default {
  namespaced: true,
  state: {
    banners: null,
    banner: null,
  },
  mutations: {
    /* eslint-disable no-param-reassign */
    [SET_BANNERS](state, banners) {
      state.banners = banners;
    },
    [SET_BANNER](state, banner) {
      state.banner = banner;
    },
    [UNSET_BANNER](state) {
      state.banner = null;
    },
    /* eslint-enable no-param-reassign */
  },
  actions: {
    getBanners({ commit }, { page }) {
      return Vue.axios.get('heros', {
        params: { page },
      }).then(({ data }) => commit(SET_BANNERS, data));
    },
    getBanner({ commit }, id) {
      return Vue.axios.get(`heros/${id}`)
        .then(({ data }) => commit(SET_BANNER, data));
    },
    unsetBanner({ commit }) {
      commit(SET_BANNER);
    },
    saveBanner({ commit }, data) {
      const { id } = data;
      const method = id ? 'put' : 'post';
      const url = id ? `heros/${id}` : 'heros';

      return Vue.axios({
        method,
        url,
        data,
      }).then((response) => {
        commit(SET_BANNER, response.data);
        return new Promise(resolve => resolve(response.data));
      });
    },
    saveBannerAssets(context, { id, params }) {
      return Vue.axios.put(`heros/${id}/assets`, params);
    },
    delete(context, id) {
      return Vue.axios.delete(`heros/${id}`);
    },
  },
  getters: {
    banners: state => state.banners,
    banner: state => state.banner,
  },
};
